<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		ControlsContainer,
		DeviceButton,
		DeviceButtonV2,
		toast,
	} from '@Shelly/shelly-design-system';
	import { postReq } from '../../../services/http';
	import { createMemberStatusSnapshot, getDeviceStatus, readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
import { devices } from 'src/stores/lists/devices';
import { temp_schemes } from 'src/stores/lists/scenes-derived';
	import { scenes } from 'src/stores/lists/scenes';
	import { extractHexId } from '../../TemperatureScheme/helpers/temp_scheme_to_ui';
	import {
		get_gen_2_control_component_channel_structure,
		is_gen_2,
		real_id,
	} from '../../../helpers/interface_helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	$: statusStore = getDeviceStatus(id);
	export let id,
		usedIn: 'list' | 'drawer' = 'list';

	$: thermostat = $temp_schemes[id];

	$: relays =
		typeof thermostat === 'object'
			? thermostat?.toheat?.blk.reduce((acc, curr) => {
					// let decId = curr?.r?.split(':')[1] || undefined;
					let dev_id = extractHexId(curr?.r || '');
					if (dev_id) {
						return [
							...acc,
							$devices[dev_id] || {
								id: dev_id,
								deleted: true,
							},
						];
					}
				}, [])
			: [];

	$: relayIds = relays?.map((dev) => dev.id) ?? [];
	$: relayStatusStore = createMemberStatusSnapshot(relayIds);
	$: relayStatus = $relayStatusStore;

	$: turn_devices =
		relays &&
		relays.filter((dev) => {
			const status = relayStatus?.[real_id(dev.id)];
			if (status) {
				if (is_gen_2(dev)) {
					if (
						(default_output === 'normal' &&
							status?.[get_gen_2_control_component_channel_structure(dev)]?.output) ||
						(default_output === 'reversed' &&
							!status?.[get_gen_2_control_component_channel_structure(dev)]?.output)
					) {
						return dev;
					}
				} else {
					if (
						(default_output === 'normal' && status?.relays?.[dev.channel]?.ison) ||
						(default_output === 'reversed' && !status?.relays?.[dev.channel]?.ison)
					) {
						return dev;
					}
				}
			}
		});
	$: default_output = thermostat?._meta?.default_output;
	$: enabled = thermostat?._enabled;
	let cacheEnabled = enabled;

	let loading = false;

	const enableDisableScene = async (data) => {
		try {
			return await postReq('/scene/enable', data);
		} catch (error) {
			console.error('There is erron on enable/disable scene id ', data.id, error);
			return { isok: false };
		}
	};

	const updateStores = (scene_script) => {
		if (scene_script !== undefined && scene_script._id !== undefined) {
			scenes.editScene(scene_script);
			/** devices statuses - update it to avoid a delay via socket update*/
			let copy_existing_scheme = { ...readDeviceStatus(scene_script._id) };

			if (copy_existing_scheme?.thermostat || copy_existing_scheme.thermostat._enabled) {
				copy_existing_scheme.thermostat._enabled = scene_script._enabled;
				devices_status.update_device_status({
					id: scene_script._id,
					msg: copy_existing_scheme,
				});
			}
		}
	};

	const change_enable_state = async () => {
		/** get all other temp schemes
		 *  (all because we don't know on other instance of app what it it,
		 *  so disable all other every time)
		 **/
		try {
			enabled = !enabled;
			loading = true;
			let other_in_the_room = Object.keys($temp_schemes).filter(
				(_k) =>
					$temp_schemes[_k]._enabled &&
					Number($temp_schemes[_k]._meta.room) !== -1 &&
					Number($temp_schemes[_k]._id) !== Number(thermostat._id) &&
					Number($temp_schemes[_k]._meta.room) === Number(thermostat._meta?.room),
			);

			if (other_in_the_room.length > 0) {
				let res: any = await postReq('/scene/bulk_enable', {
					ids: JSON.stringify(other_in_the_room),
					enabled: false,
				});
				if (res.isok) {
					for (let _id of res.data.scene_ids) {
						updateStores(res.data.scene_script[_id]);
						cacheEnabled = enabled;
					}
				}
			}
			let res: any = await enableDisableScene({
				id: thermostat._id,
				enabled: enabled,
			});

			if (res?.data?.isok || res?.isok) {
				//res data is old structure but it's possible to get it
				if (
					enabled
					// &&
					// !thermostat_status.hasOwnProperty('int_temp') &&
					// !thermostat_status.hasOwnProperty('base_temp')
				) {
					// toast.open({
					// 	type: 'info',
					// 	title: $format('temperature_sensor_initialization', {
					// 		default: 'Please wait for temperature sensor to initialize.'
					// 	}),
					// 	isTitleBold: true,
					// 	duration: 10000
					// });
				}
				updateStores(res.data.scene_script);
			}

			// const thermostat_status = $statusStore?.thermostat || {};
			loading = false;
		} catch (error) {
			toast.open({
				type: 'danger',
				title: $format('operation_failed', { default: 'Operation failed' }),
			});
		}
	};

	const controlDevices = async () => {
		await Promise.allSettled(
			turn_devices.map((device) => {
				postReq(`/device/${device.category}/control`, {
					id: real_id(device.id),
					channel: device.channel,
					turn: default_output === 'normal' ? 'off' : 'on',
				});
			}),
		)
			.then((res) => console.log(res))
			.catch((err) => console.log(err));
	};
	const a11yProps = {
		indicatorStatusText: $format(enabled ? 'button_is_enabled' : 'button_is_disabled', {
			default: enabled ? 'Button is enabled' : 'Button is disabled',
		}),
	};
</script>

{#if usedIn === 'drawer'}
	{#if $showNewLayout}
		<ControlsContainer color="color-0" class="mt-s">
			<DeviceButtonV2
				id="devicebutton-h6kq43o"
				{a11yProps}
				aria-label={$format('button_enable_disable_temperature_scheme', {
					default: 'Enable/Disable Temperature Scheme',
				})}
				class="justify-content-center"
				isWide
				size="l"
				slot="first"
				disabled={loading}
				indicator={thermostat?._meta?.type === 'cool' ? 'on' : 'off'}
				indicatorVariantOn="--color-primary"
				icon="fa fa-power-off"
				variant="primary"
				isActive={enabled ? true : false}
				on:click={async () => {
					await change_enable_state();
				}}
			/>
		</ControlsContainer>
	{:else}
		<ControlsContainer class="mt-s">
			<DeviceButton
				id="devicebutton-h6kq43o"
				{a11yProps}
				aria-label={$format('button_enable_disable_temperature_scheme', {
					default: 'Enable/Disable Temperature Scheme',
				})}
				class="justify-content-center"
				isWide
				size="l"
				slot="first"
				disabled={loading}
				indicator={thermostat?._meta?.type === 'cool' ? 'on' : 'off'}
				indicatorVariantOn="--color-primary"
				icon="fa fa-power-off"
				variant="primary"
				isActive={enabled ? true : false}
				on:click={async () => {
					await change_enable_state();
				}}
			/>
		</ControlsContainer>
	{/if}
{:else if usedIn === 'list' && $showNewLayout}
	<DeviceButtonV2
		id="devicebutton-462s9b0"
		{a11yProps}
		aria-label={$format('button_enable_disable_temperature_scheme', {
			default: 'Enable/Disable Temperature Scheme',
		})}
		class="justify-content-center"
		disabled={loading}
		indicator={thermostat?._meta?.type === 'cool' ? 'on' : 'off'}
		indicatorVariantOn="--color-primary"
		icon="fa fa-power-off"
		variant="primary"
		isActive={enabled ? true : false}
		on:click={async (e) => {
			e.stopPropagation();
			await controlDevices();
			await change_enable_state();
		}}
	/>
{:else if usedIn === 'list'}
	<DeviceButton
		id="devicebutton-462s9b0"
		{a11yProps}
		aria-label={$format('button_enable_disable_temperature_scheme', {
			default: 'Enable/Disable Temperature Scheme',
		})}
		class="justify-content-center"
		disabled={loading}
		indicator={thermostat?._meta?.type === 'cool' ? 'on' : 'off'}
		indicatorVariantOn="--color-primary"
		icon="fa fa-power-off"
		variant="primary"
		isActive={enabled ? true : false}
		on:click={async (e) => {
			e.stopPropagation();
			await controlDevices();
			await change_enable_state();
		}}
	/>
{/if}
